import { normalizeBogglePlaygroundSettings } from '~/boggle/lib/playground'
import { RACE_CORE_PRESET } from '../race/preset'

export const REBOOT_CORE_PRESET = normalizeBogglePlaygroundSettings(
  {
    boardClearBonusPoints: 5,
    combo: {
      enabled: false,
    },
    lettersRepopulate: false,
    redrawBoardAfterWord: false,
    scoreBonusMaxLength: null,
    intervalCount: 1,
    gridSize: '3x3',
    skills: {
      reset: { delaySeconds: null, enabled: true, uses: null },
    },
  },
  RACE_CORE_PRESET,
)
